import { render, staticRenderFns } from "./SelectBillingClient.vue?vue&type=template&id=5c05812c"
import script from "./SelectBillingClient.vue?vue&type=script&lang=js"
export * from "./SelectBillingClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports